export default __webpack_public_path__ + "static/media/rtl_doodle_grey.52c3c045.png";